import React, { useState } from 'react'
import PropTypes from 'prop-types'

export const MessageType = {
  Info: 'info',
  Alert: 'alert',
  Success: 'success',
  Critical: 'critical'
}

const Message = ({
  content,
  hoverContent,
  className = '',
  type = MessageType.Info
}) => {

  const [showHover, setShowHover] = useState(false)

  const messageProps = hoverContent ? {
    onMouseEnter: () => setShowHover(true),
    onMouseLeave: () => setShowHover(false)
  } : {}

  return <div className={`InlineMessage InlineMessage--${type} ${className}`} {...messageProps}>
    {content}
    {showHover && hoverContent}
  </div>
}

Message.propTypes = {
  /** A message has content to display */
  content: PropTypes.node,
  /** A message can be of various types, rendering different styling based on the type */
  type: PropTypes.oneOf([
    MessageType.Info,
    MessageType.Critical,
    MessageType.Alert,
    MessageType.Success
  ]),
  /** A message can display additional information on hover */
  hoverContent: PropTypes.node,
  /** A message can apply additional CSS classes */
  className: PropTypes.string
}

export default Message

